import axios from "@/utils/request.js";
import qs from "qs"
// 获取验证图片
const getCaptchaPic = (params) => axios({
    url: "/api/web-basic/common/util/captcha/pic",
    method: 'get',
    params
})
//发送验证码
const getCheckPic = (data) => axios({
    url: "/api/web-basic/sms/manager/login",
    method: 'post',
    data: qs.stringify(data)
})
//账户密码登录
const login = (data) => axios({
    url: "/api/web-basic/login/wap/account",
    method: 'post',
    data: qs.stringify(data)
})
//账户验证码登录
const loginMobile = (data) => axios({
    url: "/api/web-basic/login/wap/mobile",
    method: 'post',
    data: qs.stringify(data)
})
//找回密码
const forgotPassword = (data) => axios({
    url: "/api/web-conf/user/manager/password/getBack",
    method: 'post',
    data: qs.stringify(data)
})
//账户密码注册
const register = (data) => axios({
    url: "/api/web-basic/login/wap/register",
    method: 'post',
    data: qs.stringify(data)
})
export {
    getCaptchaPic,
    getCheckPic,
    login,
    loginMobile,
    forgotPassword,
    register
}